import { connect } from 'react-redux';
import {
  fetchPersonGoogleImport,
  savePerson,
} from '../../../store/modules/person';

import PersonImporter from '../components/PersonImporter';

const mapActionCreators = {
  fetchPersonGoogleImport,
  savePerson,
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, mapActionCreators)(PersonImporter);



// WEBPACK FOOTER //
// ./src/routes/PersonImporter/containers/PersonImporterContainer.js